import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config, PagingResponseModel } from '../../shared';
import { ApiVisa } from '../../shared/api-visa.model';
import { Pagination } from '../../shared';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })

export class InventoryStockCardService extends BaseApiTemplateService<any> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.INV_PREFIX + 'txn-line/stock-cards/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.INV_PREFIX + 'txn-line/stock-cards/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.INV_PREFIX + 'txn-line/stock-cards/backoffice-ep';
    this.httpClient = http;
  }

  public getTxnLine(pagination: Pagination, visa: ApiVisa):
    Observable<PagingResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>
      (url, this.getHttpHeader(visa));
  }

  public getAdjTxnLine(pagination: Pagination, visa: ApiVisa):
    Observable<PagingResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + 'line-open-queue/stock-cards/backoffice-ep' + '?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>
      (url, this.getHttpHeader(visa));
  }
}
